module.exports = __webpack_public_path__ + "img/Racine_Energie.63545fb7.png";